
import { useReducer, useRef, useState, useContext, useEffect } from "react";
import { useAccordionButton, AccordionContext, Card, Badge, Button, Fade, Row } from 'react-bootstrap';
import { isAccordionItemSelected } from 'react-bootstrap/esm/AccordionContext';
import parse from 'html-react-parser';
import ItemComment from './ItemComment/ItemComment';
import { compareJoinedElements, containsOpenComment, getHighlightHTML, highlightApi, logS, objContains, removeExtrasFromItemNum } from "./Util/Utilities";
import { textInputDataReducer } from 'Components/Forms/FormReducers/TextInputReducer';
import { ACTIONS } from "Components/Forms/FormReducers/TextInputReducer";
import { LOGGER } from "Utils/Debug/debugUtils";
import { config } from "Utils/config";


function AccordionHeader({ setDefaultFocusItem,defaultFocusItem, focusKeywordId, itemListRefs, setItemListRefs, highlighted, setHighlighted,handleStatusClose,setStatusData,setStatusVariant,setShowStatusPopup,categoryId, tempCommentList, tempCommentListDispatch, handleActiveCommentChange, commentInput, commentInputDispatch, mobile,activeCommentKey, setActiveCommentKey, activeCommentKeyValue,setActiveCommentKeyValue,eventKey, activeAccordion, setActiveAccordion, activeEl, setActiveEl, isEnd, isArrItem, item, isX, moduleItems,commentsList,commentsListDispatch }) {
    
    const [subCommentCount, setSubCommentCount] = useState(0);
    const { activeEventKey } = useContext(AccordionContext);
    const isCurrentEventKey = isAccordionItemSelected(activeEventKey, eventKey);
    const [event, setEvent] = useState(item);
    const [inputVisible, setInputVisible] = useState(false);
    const itemRef = useRef(null);
    
    useEffect(()=>{
        calculateCount();
    },[commentsList])

    useEffect(()=>{
        //console.log(defaultFocusItem, event.id);
        if(defaultFocusItem!=null && defaultFocusItem == event.id){
            
            if(event.commentable == 1){
                var success = handleActiveCommentChange(event.id).then(res=>{
                    //console.log(res);
                    if(res==true){
                        setInputVisible(true);
                    }
                });
            }
            else{
                itemRef?.current?.scrollIntoView();
            }
            setDefaultFocusItem(null);
        }
    },[])

   

    useEffect(()=>{
        //console.log(event.id);
        if(itemListRefs.hasOwnProperty(event.id)){
            //console.log(itemListRefs);
        }
        else{
            setItemListRefs(prev=>({
                ...prev,
                [event.id]: itemRef
            }))
           
        }
    },[])

    useEffect(()=>{
        if(focusKeywordId!=null && focusKeywordId.id==event.id){ 
            var occ = focusKeywordId.occ;
            if(highlighted!=null && Object.keys(highlighted).length>0){
                highlightApi(itemRef, highlighted.term, "search-results-term",occ,["split-item-num","item-num"],2);
            }
            itemRef.current.scrollIntoView({ block: "nearest" });
        }
    },[focusKeywordId, mobile, itemRef.current])

    const calculateCount = () => {
        var count = 0;
        for (const [key, value] of Object.entries(commentsList)) {
            
            var comment = value.item;
            var current = event;


            if(current!=null && comment!=null){
                
                var currSplit = removeExtrasFromItemNum(current.itemNum);
                var commSplit = removeExtrasFromItemNum(comment.itemNum);

                var currLength = currSplit.length;
                var commLength = commSplit.length;

                if(currLength < commLength && compareJoinedElements(commSplit,currLength,currSplit,".")==true){
                    count++;
                    
                }
            }
            
        }

        setSubCommentCount(count);
        return count;
    }

    const handleAddTodo = (newTodo) => {
        setActiveAccordion(prevTodos => [...prevTodos, newTodo]);
    };

    const expandCount = (e) => {
        const currentTarget = e.currentTarget; 
        config.isDebugEnabled && console.log("%c%s - %cExpand Comments%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);
        var current = event;
        var currSplit = removeExtrasFromItemNum(current.itemNum);
        var currLength = currSplit.length;
        var expand = [];

        for (const [key, value] of Object.entries(commentsList)) {
            var comment = value.item;
            var commSplit = removeExtrasFromItemNum(comment.itemNum);
            var commLength = commSplit.length;

            if(currLength <= commLength && compareJoinedElements(commSplit, currLength, currSplit, ".")==true){
                for (const mValue of moduleItems) {
                    var split = removeExtrasFromItemNum(mValue.itemNum);

                    if(split.length <= commLength && compareJoinedElements(commSplit,split.length,split,".")==true){
                        handleAddTodo(mValue.itemNum);
                        expand.push(mValue.itemNum);
                    }
                }
            }
        }
    }

    

    const handleArrowOnClick = useAccordionButton(
        eventKey,
        (e) => {
            config.isDebugEnabled && console.log("%cInitiate - %cAccordion%c - %s - %s", logS.bold, logS.colors.teal, logS.bold,isCurrentEventKey ? "Collapse" : "Expand", event.itemNum);
            if(isCurrentEventKey==false){
                setActiveAccordion([...activeAccordion, eventKey]);
                config.isDebugEnabled && console.log("%cAccordion%c - %s - %cSuccess%c - %s", logS.colors.teal, logS.bold,"Expand", logS.colors.green, logS.bold, event.itemNum);
            }
            else{
                var c = containsOpenComment(activeCommentKey, tempCommentList, event);
                
                if(c==false){
                    
                    var split = eventKey.split(".");
                    var l = split.length;
                    if(l>0 && split[l-1]=='0'){
                        split.pop();
                    }
                    var k = split.join(".");


                    setActiveAccordion(activeAccordion.filter(a => {
                        if(a!=null && a.split(".").length >= l){
                            if(a.startsWith(k)){
                                return false;
                            }
                            else{
                                return true;
                            }
                        }
                        else{
                            return true;
                        }
                    }))
                    config.isDebugEnabled && console.log("%cAccordion%c - %s - %cSuccess%c - %s", logS.colors.teal, logS.bold,"Collapse", logS.colors.green, logS.bold, event.itemNum);
                }
                else{
                    //newId,tempCommentList,commentsList,activeCommentKey,tabActiveKey,checkEmpty
                    var success = handleActiveCommentChange(event.id).then(res=>{
                        if(res==true){
                            var split = eventKey.split(".");
                            var l = split.length;
                            if(l>0 && split[l-1]=='0'){
                                split.pop();
                            }
                            var k = split.join(".");


                            setActiveAccordion(activeAccordion.filter(a => {
                                if(a!=null && a.split(".").length >= l){
                                    if(a.startsWith(k)){
                                        return false;
                                    }
                                    else{
                                        return true;
                                    }
                                }
                                else{
                                    return true;
                                }
                            }))
                            config.isDebugEnabled && console.log("%cAccordion%c - %s - %cSuccess%c - %s", logS.colors.teal, logS.bold,"Collapse", logS.colors.green, logS.bold, event.itemNum);
                        }
                        else{
                            config.isDebugEnabled && console.log("%cAccordion%c - %s - %cFailed%c - %s", logS.colors.teal, logS.bold,"Collapse", logS.colors.red, logS.bold, event.itemNum);
                        }
                    });
                    
                }
                
            }
        }
    );

    const handleAddClick = (e) => {
        const currentTarget = e.currentTarget; 
        config.isDebugEnabled && console.log("%c%s - %cAdd New Comment%c - %s - %s", logS.bold, "Click", logS.colors.orange, logS.bold,  event.itemNum, event.id, currentTarget);
        if(event.commentable == 1){
            var success = handleActiveCommentChange(event.id).then(res=>{
                //console.log(res);
                if(res==true){
                    setInputVisible(true);
                }
            });
           
        }
    };

    const getIsEndClass = () => {
        if(isEnd!=null && isEnd==true){
            return "end";
        }
        else{
            return "";
        }
    }

    return (
        <>
            <Card.Header className={getIsEndClass() +  (isX!=null && isX==true ? " x-item" : "")} key={"header-" + event.id}>
                {/* {event.id} */}
                { 
                    isEnd!=null && isEnd==true
                    ?   <div className="emptyBtn"></div>
                    :
                        <button
                            title={isCurrentEventKey ? "Collapse data element group" : "Open data element group"}
                            type="button"
                            className="ct-accordion-btn"
                            onClick={handleArrowOnClick}
                            aria-label={isCurrentEventKey ? "Collapse data element group" : "Open data element group"}
                            aria-expanded={isCurrentEventKey}
                        >
                            {   eventKey!=null
                                ?   
                                    <div className="arrow-icon-div">
                                        <svg className={isCurrentEventKey? "up-icon" : 'down-icon'} xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                            <path d="M10.59 0L6 4.58L1.41 0L0 1.41L6 7.41L12 1.41L10.59 0Z" fill="#686E7A"/>
                                        </svg>
                                    </div>
                                :   null
                            }
                        </button>
                }
                <Row
                    
                    as={event.commentable != 1 /*|| mobile==false*/ || objContains(tempCommentList,event.id)==true ? 'div' : Button}
                    //type="button"
                    className={"body ct-event-header-btn d-flex w-100 justify-content-between btn" + (event.commentable != 1  || objContains(tempCommentList,event.id)==true ? " inactive" : "")}
                    onClick={event.commentable != 1 /*|| mobile==false*/ || objContains(tempCommentList,event.id)==true ? null : handleAddClick}
                    disabled={event.commentable != 1 /*|| mobile==false*/ || objContains(tempCommentList,event.id)==true ? true : false}
                    ref={itemRef}
                >
                    <div className="d-flex d-sm-none flex-row py-0 w-100">
                        <div className="d-flex flex-column w-100">
                            {
                                isX==null || isX!=true ?
                                <div className="d-flex flex-row justify-content-between py-0 w-100 gap-2">
                                    <div className="split-item-num">{isX!=null && isX==true ? null : event.itemNum} </div>
                                    
                                </div>
                            :   null 
                            }
                                <div className="mobile-item-text">   
                                    {
                                        event.itemNameHtml!=null 
                                        ?   
                                        //highlighted.hasOwnProperty(event.id) 
                                           // ?   parse(getHighlightHTML(event.itemNameHtml, highlighted, event.id, focusKeywordId, event, itemRef))
                                            //:  
                                             parse(event.itemNameHtml)
                                        :   null
                                    }
                                </div>
                           
                        </div>
                    </div>
                    <div className="d-none d-sm-flex justify-content-between w-100">
                        <div className=" flex-row" >
                            <div className="desktop-item-text">
                                {
                                    isX!=null && isX==true 
                                    ?   null 
                                    :   <span className="item-num">{event.itemNum} </span>
                                }{
                                    event.itemNameHtml!=null 
                                    ?   
                                    //highlighted.hasOwnProperty(event.id) 
                                        //?   parse(getHighlightHTML(event.itemNameHtml, highlighted, event.id, focusKeywordId, event, itemRef))
                                        //:   
                                        parse(event.itemNameHtml)
                                    :   null
                                }
                            </div>
                        </div>
                        
                    </div>
                </Row>
                <div className="d-flex flex-row gap-2 position-absolute control-btns">
                        {   
                            event.commentable == 1 && isCurrentEventKey==false  && subCommentCount>0
                            ?   
                                <Badge as={Button} title={subCommentCount>1 ? "Open hidden comments" : "Open hidden comment"} className={"ct-count-btn" + (isCurrentEventKey? " expanded" : ' collapsed')} bg="" onClick={(e)=>{
                                    expandCount(e)
                                }}>
                                    <div className="icon-container px-1 d-flex flex-row align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                            <path d="M8.33331 1.95955V6.95955H2.15415L1.66665 7.44705V1.95955H8.33331ZM8.33331 1.12622H1.66665C1.20831 1.12622 0.833313 1.50122 0.833313 1.95955V8.45539C0.833313 8.82622 1.28331 9.01372 1.54581 8.75122L2.49998 7.79289H8.33331C8.79165 7.79289 9.16665 7.41789 9.16665 6.95955V1.95955C9.16665 1.50122 8.79165 1.12622 8.33331 1.12622Z" fill="#0C6DB0"/>
                                        </svg>
                                        <span>{subCommentCount}</span>
                                    </div>   
                                </Badge>
                            :   
                                <Badge as={Button}  className={"ct-count-btn emptyCountBtn" + (isCurrentEventKey? " expanded" : ' collapsed')} bg="" >
                                    
                                    <div className="icon-container px-1 d-flex flex-row align-items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                            <path d="M8.33331 1.95955V6.95955H2.15415L1.66665 7.44705V1.95955H8.33331ZM8.33331 1.12622H1.66665C1.20831 1.12622 0.833313 1.50122 0.833313 1.95955V8.45539C0.833313 8.82622 1.28331 9.01372 1.54581 8.75122L2.49998 7.79289H8.33331C8.79165 7.79289 9.16665 7.41789 9.16665 6.95955V1.95955C9.16665 1.50122 8.79165 1.12622 8.33331 1.12622Z" fill="#0C6DB0"/>
                                        </svg>
                                        <span>0</span>
                                    </div>
                                        
                                </Badge>
                                
                        }
                        {   event.commentable == 1 && objContains(tempCommentList,event.id)==false
                            ?
                                <button
                                    title="Add comment"
                                    type="button"
                                    className="ct-add-btn d-none d-sm-flex align-items-center justify-content-center "
                                    onClick={(e)=>handleAddClick(e)}
                                    aria-label={"Add Comment"}
                                    
                                >             
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z" fill="#2491FF"/>
                                    </svg>
                                </button>
                            :   <div className="d-none d-sm-flex  emptyAddBtn"></div>
                        }
                        </div>
                
            
            </Card.Header>
            
            {   
                event.commentable == 1 && inputVisible == true
                ?
                    <ItemComment
                        handleActiveCommentChange={handleActiveCommentChange}
                        inputVisible={inputVisible}
                        setInputVisible={setInputVisible}
                        activeCommentKey={activeCommentKey}
                        setActiveCommentKey={setActiveCommentKey}
                        activeCommentKeyValue={activeCommentKeyValue}
                        setActiveCommentKeyValue={setActiveCommentKeyValue}
                        item={event}
                        commentsList={commentsList}
                        commentsListDispatch={commentsListDispatch}
                        isArrItem={isArrItem}
                        mobile={mobile}
                        commentInput={commentInput}
                        commentInputDispatch={commentInputDispatch}
                        tempCommentList={tempCommentList}
                        tempCommentListDispatch={tempCommentListDispatch}
                        categoryId={categoryId}
                        handleStatusClose={handleStatusClose}
                        setStatusData={setStatusData}
                        setStatusVariant={setStatusVariant}
                        setShowStatusPopup={setShowStatusPopup}
                    >
                    </ItemComment>
                    
                :   null
            }
        
        </>
    );
}

export default AccordionHeader;